import axios from "axios";
import { GEOAIAPI_BASE_URL } from "utils/base_urls";

const singleton = Symbol();
const singletonEnforcer = Symbol();

class GeoAIAdminInterface {
    constructor() {
        this.session = axios.create({
            baseURL: GEOAIAPI_BASE_URL,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': `Bearer ${localStorage.getItem("tiles_api_auth0_token")}`
            }
        });
    }

    static get instance() {
        if (!this[singleton]) {
            this[singleton] = new GeoAIAdminInterface(singletonEnforcer);
        }

        return this[singleton];
    }

    getGeoAIRequests = (skip, limit) => this.session.get(`v1/management/geoai/inferences?skip=${skip}&limit=${limit}`)
    deleteGeoAIRequests = (id) => this.session.delete(`v1/management/geoai/inferences/${id}`)

    getGeoAIRequestLimits = () => this.session.get(`v1/management/geoai/inferences/limits`)
    editGeoAIRequestLimit = (limit) => this.session.put(`v1/management/geoai/inferences/limits`, limit)
}

export default GeoAIAdminInterface